import { mapGetters, mapMutations } from 'vuex';
//import _ from 'lodash';
import Swal from 'sweetalert2';

const GetFavoriteListMixin = {
  name: 'GetFavoriteListMixin',

  data() {
    return {
      isGotFavoriteList: false,
    };
  },

  methods: {
    //
    async doGetFavoriteList() {
      //
    },

    async getFavoriteList() {
      await this.doGetFavoriteList();
      this.isGotFavoriteList = true;
    },
  },
};

// ClassRestrictionMixin
// AddToFavoriteListMixin
const FavoriteListPlayerMixin = {
  name: 'FavoriteListPlayerMixin',

  data() {
    return {
      isShowPlayer: false,
    };
  },

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_readyToPlayVideos: 'readyToPlayVideos',
      mg_selectedVideo: 'selectedVideo',
      mg_nextVideo: 'nextVideo',
    }),
  },

  methods: {
    ...mapMutations('Mixins/Bookmark', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
    }),

    openPlayer() {
      this.isShowPlayer = true;
    },

    async markVideo(video) {
      await this.addToFavoriteList(video);
      const { toCollect } = video;
      Swal.fire({
        // position: 'top-end',
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${toCollect ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    goToNextVideo() {
      this.mm_SET_SELECTED_BULLET_ID(this.mg_nextVideo.bulletId);
    },

    closePlayer() {
      this.isShowPlayer = false;
      if (false === this.mg_selectedVideo.collected) {
        this.setIsDeletedInFavoriteList(this.mg_selectedVideo);
      }
    },
  },
};

// ClassRestrictionMixin
// AddToFavoriteListMixin
export const BookmarkMixin = {
  name: 'BookmarkMixin',

  mixins: [GetFavoriteListMixin, FavoriteListPlayerMixin],

  computed: {
    ...mapGetters('Mixins/Bookmark', {
      mg_favoriteList: 'favoriteList',
    }),

    c_isShowEmptyVideoList() {
      return !this.isGotFavoriteList || 0 === this.mg_favoriteList.length;
    },
  },

  methods: {
    //
    async doGetFavoriteList() {
      //
    },
  },
};

export default BookmarkMixin;
